<div class="supplier-container">
  <div class="supplier-header">
    <h2>Supplier Module</h2>
    <p-button
      label="Supplier help"
      icon="pi pi-question-circle"
      severity="secondary"
      [outlined]="true"
      (onClick)="openManual()"
    />
  </div>
  <mat-tab-group (selectedTabChange)="onMainTabChanged($event)">
    <mat-tab label="Assign">
      <div class="stepper-container" appUserManual [userManualKey]="'supplier-assignment-stepper'">
        <mat-horizontal-stepper [linear]="true" #stepper>
          <mat-step [stepControl]="procurementPackageForm" [editable]="true">
            <ng-template matStepLabel>
              <span class="step-label-pill" [class.completed]="getStepState(stepper, 0) === 'completed'">
                <mat-icon *ngIf="getStepState(stepper, 0) === 'completed'" class="pill-icon" aria-hidden="true">check</mat-icon>
                <span>Select Scope</span>
              </span>
            </ng-template>
            <form [formGroup]="procurementPackageForm">
              <div class="step-actions">
                <div class="left-actions">
                  <!-- empty on purpose for left alignment in first step -->
                </div>
                <div class="right-actions">
                  <button
                    type="button"
                    class="aker-context-button"
                    mat-raised-button
                    matStepperNext
                    [disabled]="procurementPackageForm?.invalid"
                    aria-label="Next"
                  >
                    <mat-icon>arrow_forward</mat-icon>
                    <span>Next</span>
                  </button>
                </div>
              </div>
              <app-purchase-order></app-purchase-order>
            </form>
          </mat-step>

          <mat-step [stepControl]="supplierForm" [editable]="true">
            <ng-template matStepLabel>
              <span class="step-label-pill" [class.completed]="getStepState(stepper, 1) === 'completed'">
                <mat-icon *ngIf="getStepState(stepper, 1) === 'completed'" class="pill-icon" aria-hidden="true">check</mat-icon>
                <span>Select Supplier</span>
              </span>
            </ng-template>
            <form [formGroup]="supplierForm">
              <div class="step-actions">
                <div class="left-actions">
                  <button type="button" class="aker-context-button" mat-raised-button matStepperPrevious aria-label="Back">
                    <mat-icon>arrow_back</mat-icon>
                    <span>Back</span>
                  </button>
                </div>
                <div class="right-actions">
                  <button
                    type="button"
                    class="aker-context-button"
                    mat-raised-button
                    matStepperNext
                    [disabled]="!hasSelectedSuppliers"
                    aria-label="Next"
                  >
                    <mat-icon>arrow_forward</mat-icon>
                    <span>Next</span>
                  </button>
                </div>
              </div>
              <app-select-supplier></app-select-supplier>
            </form>
          </mat-step>

          <mat-step [stepControl]="verifyForm" [editable]="true">
            <ng-template matStepLabel>
              <span class="step-label-pill" [class.completed]="getStepState(stepper, 2) === 'completed'">
                <mat-icon *ngIf="getStepState(stepper, 2) === 'completed'" class="pill-icon" aria-hidden="true">check</mat-icon>
                <span>Verify Selection</span>
              </span>
            </ng-template>
            <form [formGroup]="verifyForm">
              <div class="step-actions">
                <div class="left-actions">
                  <button type="button" class="aker-context-button" mat-raised-button matStepperPrevious aria-label="Back">
                    <mat-icon>arrow_back</mat-icon>
                    <span>Back</span>
                  </button>
                </div>
                <div class="right-actions">
                  <button
                    type="button"
                    class="aker-context-button complete-button"
                    mat-raised-button
                    (click)="onComplete(stepper)"
                    aria-label="Complete"
                  >
                    <mat-icon>check_circle</mat-icon>
                    <span>Complete</span>
                  </button>
                </div>
              </div>
              <app-verify-selection></app-verify-selection>
            </form>
          </mat-step>

          <mat-step [editable]="false">
            <ng-template matStepLabel>
              <span class="step-label-pill" [class.completed]="getStepState(stepper, 3) === 'completed'">
                <mat-icon *ngIf="getStepState(stepper, 3) === 'completed'" class="pill-icon" aria-hidden="true">check</mat-icon>
                <span>Completed</span>
              </span>
            </ng-template>
            <div class="step-actions">
              <div
                class="left-actions"
                *ngIf="
                  (completedRef?.transmittalStatus$ | async) !== completedRef?.TransmittalSendingState.SENDING &&
                  (completedRef?.transmittalStatus$ | async) !== completedRef?.TransmittalSendingState.SENT
                "
              >
                <button type="button" class="aker-context-button" mat-raised-button matStepperPrevious aria-label="Back">
                  <mat-icon>arrow_back</mat-icon>
                  <span>Back</span>
                </button>
              </div>
              <div class="right-actions"></div>
            </div>
            <app-completed
              #completedRef="completed"
              (resetState)="reset(stepper)"
              (cancelSend)="onCancelSendForStepper(stepper)"
            ></app-completed>
          </mat-step>
        </mat-horizontal-stepper>
      </div>
    </mat-tab>
    <mat-tab label="Assign LINE">
      <div class="stepper-container" appUserManual [userManualKey]="'supplier-assignment-stepper'">
        <mat-horizontal-stepper [linear]="true" #lineStepper>
          <mat-step [stepControl]="procurementPackageForm" [editable]="true">
            <ng-template matStepLabel>
              <span class="step-label-pill" [class.completed]="getStepState(lineStepper, 0) === 'completed'">
                <mat-icon *ngIf="getStepState(lineStepper, 0) === 'completed'" class="pill-icon" aria-hidden="true">check</mat-icon>
                <span>Select LINE Scope</span>
              </span>
            </ng-template>
            <form [formGroup]="procurementPackageForm">
              <div class="step-actions">
                <div class="left-actions"></div>
                <div class="right-actions">
                  <button
                    type="button"
                    class="aker-context-button"
                    mat-raised-button
                    matStepperNext
                    [disabled]="procurementPackageForm?.invalid"
                    aria-label="Next"
                  >
                    <mat-icon>arrow_forward</mat-icon>
                    <span>Next</span>
                  </button>
                </div>
              </div>
              <app-line-tag-scope></app-line-tag-scope>
            </form>
          </mat-step>

          <mat-step [stepControl]="supplierForm" [editable]="true">
            <ng-template matStepLabel>
              <span class="step-label-pill" [class.completed]="getStepState(lineStepper, 1) === 'completed'">
                <mat-icon *ngIf="getStepState(lineStepper, 1) === 'completed'" class="pill-icon" aria-hidden="true">check</mat-icon>
                <span>Select Supplier</span>
              </span>
            </ng-template>
            <form [formGroup]="supplierForm">
              <div class="step-actions">
                <div class="left-actions">
                  <button type="button" class="aker-context-button" mat-raised-button matStepperPrevious aria-label="Back">
                    <mat-icon>arrow_back</mat-icon>
                    <span>Back</span>
                  </button>
                </div>
                <div class="right-actions">
                  <button
                    type="button"
                    class="aker-context-button"
                    mat-raised-button
                    matStepperNext
                    [disabled]="!hasSelectedSuppliers"
                    aria-label="Next"
                  >
                    <mat-icon>arrow_forward</mat-icon>
                    <span>Next</span>
                  </button>
                </div>
              </div>
              <app-select-supplier></app-select-supplier>
            </form>
          </mat-step>

          <mat-step [stepControl]="verifyForm" [editable]="true">
            <ng-template matStepLabel>
              <span class="step-label-pill" [class.completed]="getStepState(lineStepper, 2) === 'completed'">
                <mat-icon *ngIf="getStepState(lineStepper, 2) === 'completed'" class="pill-icon" aria-hidden="true">check</mat-icon>
                <span>Verify Selection</span>
              </span>
            </ng-template>
            <form [formGroup]="verifyForm">
              <div class="step-actions">
                <div class="left-actions">
                  <button type="button" class="aker-context-button" mat-raised-button matStepperPrevious aria-label="Back">
                    <mat-icon>arrow_back</mat-icon>
                    <span>Back</span>
                  </button>
                </div>
                <div class="right-actions">
                  <button
                    type="button"
                    class="aker-context-button complete-button"
                    mat-raised-button
                    (click)="onComplete(lineStepper)"
                    aria-label="Complete"
                  >
                    <mat-icon>check_circle</mat-icon>
                    <span>Complete</span>
                  </button>
                </div>
              </div>
              <app-verify-selection></app-verify-selection>
            </form>
          </mat-step>

          <mat-step [editable]="false">
            <ng-template matStepLabel>
              <span class="step-label-pill" [class.completed]="getStepState(lineStepper, 3) === 'completed'">
                <mat-icon *ngIf="getStepState(lineStepper, 3) === 'completed'" class="pill-icon" aria-hidden="true">check</mat-icon>
                <span>Completed</span>
              </span>
            </ng-template>
            <div class="step-actions">
              <div
                class="left-actions"
                *ngIf="
                  (lineCompletedRef?.transmittalStatus$ | async) !== lineCompletedRef?.TransmittalSendingState.SENDING &&
                  (lineCompletedRef?.transmittalStatus$ | async) !== lineCompletedRef?.TransmittalSendingState.SENT
                "
              >
                <button type="button" class="aker-context-button" mat-raised-button matStepperPrevious aria-label="Back">
                  <mat-icon>arrow_back</mat-icon>
                  <span>Back</span>
                </button>
              </div>
              <div class="right-actions"></div>
            </div>
            <app-completed
              #lineCompletedRef="completed"
              (resetState)="reset(lineStepper)"
              (cancelSend)="onCancelSendForStepper(lineStepper)"
            ></app-completed>
          </mat-step>
        </mat-horizontal-stepper>
      </div>
    </mat-tab>
    <mat-tab label="Manage">
      <app-manage-suppliers></app-manage-suppliers>
    </mat-tab>
    <mat-tab label="User view">
      <app-user-view></app-user-view>
    </mat-tab>
    <mat-tab label="Scope view">
      <app-scope-view></app-scope-view>
    </mat-tab>
  </mat-tab-group>
</div>

<p-dialog
  header="Supplier Module User Manual"
  [(visible)]="manualDialogVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: 'min(1000px, 96vw)' }"
  styleClass="supplier-manual-dialog"
>
  <div class="manual-dialog-actions">
    <a href="assets/manuals/supplier-module-user-manual.html" target="_blank" rel="noopener">Open in a new tab or print</a>
  </div>
  <iframe
    class="manual-dialog-frame"
    src="assets/manuals/supplier-module-user-manual.html"
    title="Supplier Module User Manual"
  ></iframe>
</p-dialog>
